<template>
  <v-card class="savitarna-aprasymas-card" v-if="enableTooltip" elevation="0">
    <v-card-title class="savitarna-aprasymas-card-title">
      <v-spacer />
      <v-icon dense @click="closeAprasymas">mdi-close</v-icon>
    </v-card-title>
    <v-card-text class="savitarna-aprasymas-card-text text-justify">
      <span class="tooltip-santrauka" v-html="tooltipTekstas"></span>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ElPaslaugaAprasymas',
  props: {
    tooltip: String,
  },
  data() {
    return {
      // showTooltip: false,
    }
  },
  computed: {
    ...mapGetters(['infoTooltips']),
    isLocal() {
      return (
        process.env.VUE_APP_LOCAL === 'local' ||
        process.env.VUE_APP_LOCAL === 'develop' ||
        process.env.VUE_APP_LOCAL === 'test'
      )
    },
    showEmpty() {
      return this.tooltip && this.isLocal
    },
    enableTooltip() {
      return (
        (this.tooltipTekstas !== '' && this.tooltipItem.too_aktyvus === true) ||
        this.showEmpty
      )
    },
    tooltipItem() {
      return (
        this.infoTooltips.find(item => item.too_kodas === this.tooltip) ?? {}
      )
    },
    tooltipTekstas() {
      return this.tooltipItem.too_tekstas
        ? this.tooltipItem.too_tekstas
        : this.showEmpty
        ? this.tooltip
        : ''
    },
    showTooltip() {
      return this.tooltip
    },
  },
  methods: {
    closeAprasymas() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.savitarna-aprasymas-card {
  background-color: rgb(253, 251, 238) !important;
  opacity: 1;
}
.savitarna-aprasymas-card-title {
  padding: 10px 16px 0 16px;
}
.savitarna-aprasymas-card-text {
  color: rgb(102, 102, 102);
  font-size: 11px;
  p {
    margin-bottom: 0px;
  }
}
.tooltip-santrauka p {
  margin-bottom: 3px;
}
</style>
